import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (
    theme,
    {
      isKiteUser,
      placeholderGradientPercentage,
      required,
      inSidebarOnMobile,
      helperTextPosition,
    } = {},
  ) => {
    const absoluteHelperTop = inSidebarOnMobile ? '45px' : '34px';
    const helperTop =
      helperTextPosition === 'absolute' ? absoluteHelperTop : 'unset';

    return {
      root: {
        '& .MuiOutlinedInput-root': {
          color: theme.palette.darkGrey,
          padding: `8px 10px !important`,

          '& .MuiButtonBase-root': {
            padding: 4,
          },
          '& .MuiInputAdornment-root': {
            marginLeft: 8,
          },
          '& fieldset': {
            borderColor: theme.palette.grey1,
          },
          '& svg': {
            fill: isKiteUser ? theme.palette.primary1 : theme.palette.primary2,
          },
          '&.Mui-disabled svg': {
            fill: theme.palette.grey2,
          },
          '& input': {
            marginLeft: 0,
            fontSize: 'inherit',
            [theme.breakpoints.down('md')]: {
              fontSize: '14px',
            },
            '&::placeholder': {
              ...(required && {
                opacity: 1,
                background: `-webkit-linear-gradient(left, #AAA 0%, #AAA ${placeholderGradientPercentage}%, red 0%, red 0%)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }),
              [theme.breakpoints.down('md')]: {
                fontSize: 14,
                background: `-webkit-linear-gradient(left, #AAA 0%, #AAA ${
                  placeholderGradientPercentage * 0.87
                }%, red 0%, red 0%)`,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              },
            },
          },
          ...(inSidebarOnMobile && {
            [theme.breakpoints.down('md')]: {
              padding: `13px 12px !important`,
            },
          }),
        },
        '& .MuiFormHelperText-root': {
          marginInline: 0,
          position: helperTextPosition,
          top: helperTop,
          overflowX: 'shown',
          width: 'max-content',
          fontSize: '14px',
          [theme.breakpoints.down('md')]: {
            fontSize: '10px',
          },
        },
      },
      paper: {
        borderRadius: 12,
        boxShadow: '0px 5px 17px rgba(44, 112, 172, 0.2)',
        marginTop: 15,
      },
      dialog: {
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(48, 85, 107, 0.2)',
        },
        '& .MuiPaper-root': {
          borderTopLeftRadius: 10,
          borderTopRightRadius: 10,
          borderBottomRightRadius: 0,
          borderBottomLeftRadius: 0,
          bottom: 0,
          margin: 0,
          position: 'absolute',
        },
        '& .MuiDialogActions-root': {
          display: 'none !important',
        },
        '& .MuiCalendarPicker-root': {
          '& > div': {
            '&:first-child': {
              position: 'relative',
              '& .MuiPickersArrowSwitcher-root': {
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
              },
              '& > div:first-child': {
                right: '50%',
                transform: 'translate(50%, 0)',
                position: 'absolute',
              },
            },
          },
        },
      },
      calendarIcon: {
        zIndex: -1,
        top: '8px',
        position: 'absolute',
        marginRight: '8px',
        width: 18,
        height: 18,
        ...(inSidebarOnMobile && {
          [theme.breakpoints.down('md')]: {
            top: '12px',
          },
        }),
      },
    };
  },
);
